import { render, staticRenderFns } from "./FlyingRoomRegion.vue?vue&type=template&id=1a9a46e6&scoped=true"
import script from "./FlyingRoomRegion.vue?vue&type=script&lang=js"
export * from "./FlyingRoomRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a46e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9a46e6')) {
      api.createRecord('1a9a46e6', component.options)
    } else {
      api.reload('1a9a46e6', component.options)
    }
    module.hot.accept("./FlyingRoomRegion.vue?vue&type=template&id=1a9a46e6&scoped=true", function () {
      api.rerender('1a9a46e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/FlyingRoomRegion.vue"
export default component.exports